import { shape as shapeTokens } from './tokens';

const shape = {
  borderRadius: shapeTokens.borderRadius,
};

export default shape;
